import { useState, useEffect } from 'react'
import { SearchEmpty, Cross } from '../Icon/icon'
import TitleBar from '../TitleBar/TitleBar'
import style from './SearcherNoResults.module.scss'

interface SearcherNoResultsDisplayProps {
  keyword: string
  onCloseParent: () => void
}

const SearcherNoResultsDisplay = ({
  keyword,
  onCloseParent,
}: SearcherNoResultsDisplayProps) => {
  const [isVisible, setIsVisible] = useState(false)

  useEffect(() => {
    setIsVisible(true)
  }, [keyword])

  const titleBarInfo = (
    <h3 className={style.title}>
      搜尋
      <span className={style['highlighted-keyword']}>{`『${keyword.length > 10 ? keyword.substring(0, 11) + '...' : keyword}』`}</span>
      的結果：
    </h3>
  )
  const titleBarButton = (
    <button
      onClick={() => {
        setIsVisible(false)
        onCloseParent()
      }}
    >
      <Cross />
    </button>
  )
  return (
    <div>
      {isVisible && (
        <section className={style.container}>
          <TitleBar infoComponent={titleBarInfo} buttonComponent={titleBarButton} />
          <div className={style['middle-align']}>
            <SearchEmpty />
          </div>
          <h4 className={style['search-result']}>
            很抱歉，查無
            <span className={style['highlighted-keyword']}>{`『${keyword.length > 10 ? keyword.substring(0, 11) + '...' : keyword}』`}</span>
            的相關商品
          </h4>
          <h4 className={style['middle-align']}>請調整搜尋的關鍵字再試試看！</h4>
        </section>
      )}
    </div>
  )
}

export default SearcherNoResultsDisplay
